/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmailScheduleDto,
} from '../models/index';
import {
    EmailScheduleDtoFromJSON,
    EmailScheduleDtoToJSON,
} from '../models/index';

export interface ScheduleEmailRequest {
    emailScheduleDto: EmailScheduleDto;
}

/**
 * 
 */
export class EmailServiceApi extends runtime.BaseAPI {

    /**
     */
    async scheduleEmailRaw(requestParameters: ScheduleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['emailScheduleDto'] == null) {
            throw new runtime.RequiredError(
                'emailScheduleDto',
                'Required parameter "emailScheduleDto" was null or undefined when calling scheduleEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/schedule`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailScheduleDtoToJSON(requestParameters['emailScheduleDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async scheduleEmail(requestParameters: ScheduleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.scheduleEmailRaw(requestParameters, initOverrides);
    }

}
